import { api_v1_partners_path } from '../../routes';
import request from './request';

export interface Partner {
  id: number;
  buttonText?: string;
  description: string;
  logo: string;
  name: string;
  targetLink: string;
}

export async function fetchPartners(): Promise<Partner[]> {
  const resp = await request('get', api_v1_partners_path());
  return resp;
}
